/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Link } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import type { FC } from 'react';

import { rhythm } from './styles/typography';
import type { Post } from './hooks/use-posts';

type DevlogPreviewProps = {
  post: Post;
};

const DevlogPreview: FC<DevlogPreviewProps> = ({ post }) => (
  <article
    css={css`
      border-bottom: 1px solid #ddd;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-top: 0;
      padding: 1rem 0;

      &:last-child {
        border-bottom: none;
      }
    `}
  >
    <Link
      to={post.path}
      css={css`
        align-self: flex-start;
        min-width: 100px;
        display: none;

        @media screen and (min-width: 60em) {
          & {
            display: initial;
          }
        }
      `}
    >
      <GatsbyImage
        css={css`
          border-radius: 3px;
          pointer-events: none;
          user-select: none;
        `}
        image={post.image.sharp.gatsbyImageData}
        alt={post.title}
      />
    </Link>

    <div
      css={css`
        flex: 1;

        @media screen and (min-width: 60em) {
          & {
            flex: 0.97;
          }
        }
      `}
    >
      <h3
        css={css`
          margin: 0 0 ${rhythm(0.5)};
        `}
        title={post.title}
      >
        <Link to={post.path}>{post.title}</Link>
      </h3>

      <p
        css={css`
          color: hsla(0, 0%, 0%, 0.63);
          margin: 0;
        `}
      >
        {post.excerpt}
      </p>
    </div>
  </article>
);

export default DevlogPreview;
